module.exports = __webpack_public_path__ + "static/Hend-23167a9a4ac2737d585ab472b502c1cb.png";